import script from "./FoldersSelectAllModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FoldersSelectAllModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__